var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 51,
    viewBox: "0 0 36 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 44.3999,
    r: 6,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3352 27.5999V25.9897C15.3447 25.7931 13.6754 25.0208 12.3273 23.6725C10.979 22.3244 10.2067 20.6551 10.0101 18.6646H8.3999V17.3159H10.0101C10.2067 15.3252 10.979 13.6591 12.3273 12.3174C13.6754 10.9757 15.3447 10.2067 17.3352 10.0101V8.3999H18.6839V10.0101C20.6746 10.2067 22.3407 10.9757 23.6824 12.3174C25.0241 13.6591 25.7931 15.3252 25.9897 17.3159H27.5999V18.6646H25.9897C25.7931 20.6551 25.0241 22.3244 23.6824 23.6725C22.3407 25.0208 20.6746 25.7931 18.6839 25.9897V27.5999H17.3352ZM22.7294 22.7099C24.0235 21.4029 24.6706 19.8264 24.6706 17.9804C24.6706 16.1345 24.0235 14.5645 22.7294 13.2704C21.4353 11.9763 19.8653 11.3292 18.0194 11.3292C16.1734 11.3292 14.5969 11.9763 13.2899 13.2704C11.9828 14.5645 11.3292 16.1345 11.3292 17.9804C11.3292 19.8264 11.9828 21.4029 13.2899 22.7099C14.5969 24.017 16.1734 24.6706 18.0194 24.6706C19.8653 24.6706 21.4353 24.017 22.7294 22.7099ZM15.6926 20.3072C15.0592 19.6738 14.7425 18.9047 14.7425 17.9999C14.7425 17.0951 15.0592 16.326 15.6926 15.6926C16.326 15.0592 17.0951 14.7425 17.9999 14.7425C18.9047 14.7425 19.6738 15.0592 20.3072 15.6926C20.9406 16.326 21.2573 17.0951 21.2573 17.9999C21.2573 18.9047 20.9406 19.6738 20.3072 20.3072C19.6738 20.9406 18.9047 21.2573 17.9999 21.2573C17.0951 21.2573 16.326 20.9406 15.6926 20.3072ZM19.3482 19.3482C19.7217 18.9746 19.9085 18.5252 19.9085 17.9999C19.9085 17.4746 19.7217 17.0252 19.3482 16.6516C18.9746 16.2781 18.5252 16.0913 17.9999 16.0913C17.4746 16.0913 17.0252 16.2781 16.6516 16.6516C16.2781 17.0252 16.0913 17.4746 16.0913 17.9999C16.0913 18.5252 16.2781 18.9746 16.6516 19.3482C17.0252 19.7217 17.4746 19.9085 17.9999 19.9085C18.5252 19.9085 18.9746 19.7217 19.3482 19.3482Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarker);
export default __webpack_public_path__ + "static/media/map_marker.40665058cd6a7678b73fd1adfbf4e511.svg";
export { ForwardRef as ReactComponent };